import { api } from "@/api/base-api"

export type HarnessCustomer = {
  id: number
  name: string
  abbreviation: string
  customerWebsite: string | null
  planName: string | null
}

export type HarnessCustomersPage = {
  totalNumberOfItems: number
  totalNumberOfPages: number
  currentPageIndex: number
  data: HarnessCustomer[]
}

export type GetHarnessCustomersQueryArgs = {
  pageIndex?: number
  pageSize?: number
}

const customersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHarnessCustomers: builder.query<HarnessCustomersPage, GetHarnessCustomersQueryArgs | void>({
      query: (args) => ({
        url: "/api/providers/Harness/CloudFitPortal/Customer",
        params: {
          pageIndex: args?.pageIndex ?? 0,
          pageSize: args?.pageSize ?? 200,
        },
      }),
    }),
  }),
})

export const { useGetHarnessCustomersQuery } = customersApi
